export const getTranslationKeyAndParams = (name = '') => {
  const match = name.match(/^(.*?)(\d+)$/);
  if (match) {
    return { key: match[1], params: { count: Number(match[2]) } };
  }
  return { key: name, params: {} };
};
